import { render, staticRenderFns } from "./listing-box-trades.vue?vue&type=template&id=a985b67e&scoped=true&"
import script from "./listing-box-trades.vue?vue&type=script&lang=js&"
export * from "./listing-box-trades.vue?vue&type=script&lang=js&"
import style0 from "./listing-box-trades.vue?vue&type=style&index=0&id=a985b67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a985b67e",
  null
  
)

export default component.exports